export default __webpack_public_path__ + "static/media/uva.2d632cfa.png";